<script setup>
// Reemplaça <Button> de PrimeVue. Tema tailwind-light (variant `default`):
// fons i vora blancs, text negre, padding .75rem 1rem, radi .375rem,
// hover #ECECEC, disabled opacity .6. El label va en pes 500 (.p-button-label).
// La variant `solid` és la inversa (negre sobre crema) per a crides d'acció
// que han de destacar sobre el fons del body.
const props = defineProps({
  label: { type: String, default: undefined },
  type: { type: String, default: 'button' },
  variant: { type: String, default: 'default' },
})

const variantClass = computed(() =>
  props.variant === 'solid'
    ? 'border-[#333333] bg-[#333333] text-white hover:border-black hover:bg-black'
    : 'border-white bg-white text-black hover:border-[#ECECEC] hover:bg-[#ECECEC]',
)
</script>

<template>
  <button
    :type="type"
    class="relative inline-flex cursor-pointer items-center justify-center overflow-hidden rounded-md border px-4 py-3 text-center text-base transition-colors duration-200 disabled:pointer-events-none disabled:opacity-60"
    :class="variantClass"
  >
    <slot>
      <span class="font-medium">{{ label }}</span>
    </slot>
  </button>
</template>
